import { render, staticRenderFns } from "./DeveloperProfile.vue?vue&type=template&id=3ace6c3c&scoped=true&"
import script from "./DeveloperProfile.vue?vue&type=script&lang=ts&"
export * from "./DeveloperProfile.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperProfile.vue?vue&type=style&index=0&id=3ace6c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace6c3c",
  null
  
)

export default component.exports